import Link from '@Components/common/Link';
import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const Card = styled.div`
  margin: 35px 0 14px 0;
  padding: 24px 30px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.innerProduct.lightGray};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 273px;
  height: 218px;
  justify-content: space-between;
  ${mq(992)} {
    display: none;
  }
`;

export const IconWrapper = styled.div`
  max-width: 60px;
  min-width: 60px;
  max-height: 60px;
  min-height: 60px;
  /* margin-bottom: 20px; */
`;

export const P = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  color: ${({ theme }) => theme.colors.lightPurple};
  font-size: ${({ theme }) => theme.fontsizes.body14};
  overflow: hidden;
  text-align: center;
  line-height: 1.5;
  margin: auto;
`;

export const ShopNowArrow = styled.div`
  max-width: 24px;
  min-width: 24px;
  max-height: 24px;
  min-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(-1, 1) /*rtl: none */;
  /* padding-right: 8px; */
`;

export const ShopNow = styled(Link)`
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  color: ${({ theme }) => theme.colors.cartCountColor};
  font-size: ${({ theme }) => theme.fontsizes.body14};
  display: flex;
  align-items: center;
`;
